const PlantsNickname = require("./PlantsNickname")

module.exports = {
    scssVariables: './src/styles/synisf2023',
    randomNickname: () => { return PlantsNickname.RandomNickname() },
    defaultLanguage: 'en',
    profileColor: {saturation: 70, brightness: 70},
    favicon: 'sgpfavicon.ico',
    defaultPassword: 'seedcare'
}